import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { Layout } from "../../../ui/layout"
import { ButtonComponent } from "../../../ui/molecules/button/newButton"
import { MadfarmStaticSelect } from "../../../ui/molecules/select/newSelect/static"
import { CustomHorizontalTab } from "../../../ui/organisms/customHorizontalTab"
import { MenuItems } from "../../../ui/organisms/navbar/dto"
import { statoRichiestaComplianceRequest, yearOptions } from "../../../utils"
import { SOTFilter } from "../../sot"
import { AllRequests } from "./allRequests"
import { CustomerList } from "./customerList"
import { GetAllComplianceRequests, resetfilters, setRequestFilterSot, setRequestFilterState, setRequestFilterYear } from "./slice"

export function ComplianceRequests() {
    const navigate = useNavigate()
    const [selectedTab, setSelectedTab] = useState<number>(0)
    const sessionState = useAppSelector(state => state.session)
    const complianceRequestState = useAppSelector(state => state.complianceRequest)
    const dispatch = useAppDispatch()

    return (
        <Layout
            menuItem={MenuItems.GESTIONE_CERTIFICAZIONE}
            breadcrumbItems={['Gestione Certificazione', 'Richieste di Conformità']}
            noPaddingLat
            headerLabel="Richieste di Conformità"
            headerChildren={
                <div className="flex items-center h-[100%] w-[100%] justify-end">
                    {
                        (sessionState.selected.customerId) &&
                        <ButtonComponent
                            size={"sm"}
                            iconPosition={"off"}
                            variant={"solid"}
                            label="Crea nuova richiesta"
                            color={"orange"}
                            disabled={!sessionState.selected.customerId}
                            onClick={() => {
                                navigate('/addComplianceRequest')
                            }}
                        />
                    }


                </div>
            }
        >
            <CustomHorizontalTab
                selectedIndex={selectedTab}
                onTabClick={(index) => setSelectedTab(index)}
            >
                <div>Elenco cliente</div>
                <div>Elenco completo</div>
            </CustomHorizontalTab>
            {
                (selectedTab === 1) && (
                    <div className="flex flex-row items-center gap-2 p-4 w-full">
                        <MadfarmStaticSelect
                            isClearable
                            noOptionsMessage=""
                            value={complianceRequestState.complianceRequestFilters.year}
                            placeholder={'Anno'}
                            options={yearOptions}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setRequestFilterYear(newValue))
                            }}
                        />
                        <SOTFilter
                            value={complianceRequestState.complianceRequestFilters.headQuarter}
                            // disabled={usersState.findMeResponse.headQuarterInfo?.code !== 'SC' && usersState.findMeResponse.role !== 'admin'}
                            onChange={(value) => dispatch(setRequestFilterSot(value))}
                        />
                        <MadfarmStaticSelect
                            isClearable
                            noOptionsMessage=""
                            placeholder={'Stato'}
                            value={complianceRequestState.complianceRequestFilters.state}
                            options={statoRichiestaComplianceRequest}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setRequestFilterState(newValue))
                            }}
                        />
                        <div className="flex flex-row gap-2 items-center">
                            <ButtonComponent
                                size={"lg"}
                                iconPosition={"off"}
                                variant={"outline"}
                                label="Pulisci"
                                color={"gray"}
                                onClick={() => dispatch(resetfilters())}
                            />
                            <ButtonComponent
                                variant='outline'
                                color='orange'
                                size='lg'
                                iconPosition='off'
                                label='Cerca'
                                onClick={() => dispatch(GetAllComplianceRequests(complianceRequestState.complianceRequestFilters))}
                            />
                        </div>
                    </div>
                )
            }
            <div className="fieldset bg-brandPrimary-200">
                {
                    selectedTab === 0 &&
                    <CustomerList />
                }
                {
                    selectedTab === 1 &&
                    <AllRequests />
                }
            </div>
        </Layout>
    )
}